export const pt = {
    general: {
        product: {
            insert: "Enxerto",
        }
    },

    inputPlaceholder: {
        pdfFiles: "Clique aqui ou arraste seus arquivos PDF.",
        addImage: "Clique aqui ou arraste a imagem.",
        select: "Selecionar",
        required_field: "Campo obrigatório"
    },
    claims: {
        reimbursables: {
            cost_cubbo: "Custo Operacional Cubbo",
            cost_shipping: "Custo de guia do pedido",
            product_value: "Valor indicado do produto",
            cost_shipping_replace: "Custo de guia para enviar a reposição do pedido",
            cost_shipping_reposition: "Custo do guia para enviar reposição de pedidos",
            return_cost: 'Custo da guia de devolução do produto errado'
        },
        motives: {
            delivery_delay: 'Pedido foi coletado pela transportadora mas está sem movimentação.',
            false_delivery: 'O status do pedido indica que o pedido foi entregue, mas meu cliente não o recebeu.',
            package_stolen: 'O status do pedido indica que foi roubado.',
            package_lost: 'O status do pedido indica que foi extraviado ou roubado.',
            damaged_product: 'Pedido foi entregue avariado.',
            incorrect_content: 'Pedido entregue não corresponde ao que o cliente encomendou.',
            none_of_the_above: 'Nenhuma das opções acima.',
            missing_products: 'Faltaram produtos no pedido',
            unwanted_products: 'Produtos não encomendados foram recebidos',
            wrong_order: 'Meu cliente recebeu um pedido completo que não era dele.',
            paid_product: '...algo que meu cliente comprou.',
            promotional_product: '...algo que deveria ter sido enviado como um produto promocional.'
        },
        motive_names: {
            unwanted_products: "Producto incorrecto",
            missing_products: "Producto faltante",
            wrong_order: "Guía cruzada",
            operations_others: "Otros - Operaciones",
            damaged_product: "Dañado",
            incorrect_charge: "Mal cobrado",
            other: "Otro - Área del Comercial",
            origin_error: "Error de origen",
            package_lost: "Perdido",
            damaged_product: "Dañado",
            delivery_delay: "Demora en entrega",
            false_delivery: "Entrega Incorrecta",
            package_stolen: "Robo",
            delivery_others: "Otros - Paquetería",
            missing_products: "Producto faltante"
        },
        operations: {
            unwanted_products: {
                description: "Producto incorrecto",
                recomendation: "Lembramos que pode duplicar a encomenda com incidência e ajustar os produtos a reenviar para enviar ao seu cliente os produtos pendentes.",
            },
            missing_products: {
                description: "Producto faltante",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",
            },
            wrong_order: {
                description: "Guía cruzada",
                recomendation: "Atenção: Acesse o link para realizar corretamente o reenvio de um pedido que sofreu algum incidente:",
                url: "https://scribehow.com/shared/Como_gerar_Reenvio_de_Pedido__QPK47MegT3qhfXZB7Wcrog"
            },
            operations_others: {
                description: "Otros - Operaciones",
                recomendation: "",

            }

        },
        commercial: {
            unwanted_products: {
                description: "Producto incorrecto",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",
            },
            wrong_order: {
                description: "Guía cruzada",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",
            },
            operations_others: {
                description: "Otros - Operaciones",
                recomendation: "",
            },
            damaged_product: {
                description: "Dañado",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",
            },
            package_lost: {
                description: "Perdido",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",

            },
            delivery_delay: {
                description: "Demora en entrega",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",

            },
            false_delivery: {
                description: "Entrega Incorrecta",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",

            },
            package_stolen: {
                description: "Robo",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",

            },
            missing_products_delivery: {
                description: "Producto faltante - Paquetería",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",
            },
            missing_products_operations: {
                description: "Producto faltante - Operaciones",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",
            },
        },
        client: {
            origin_error: {
                description: "Error de origen",
                recomendation: "",

            },
            other: {
                description: "Otro - Área del cleinte",
                recomendation: "",

            }
        },
        delivery: {
            package_lost: {
                description: "Perdido",
                recomendation: "Atenção: Acesse o link para realizar corretamente o reenvio de um pedido que sofreu algum incidente:.",
                url: "https://scribehow.com/shared/Como_gerar_Reenvio_de_Pedido__QPK47MegT3qhfXZB7Wcrog"
            },
            damaged_product: {
                description: "Dañado",
                recomendation: "Lembramos que você pode duplicar o pedido com incidência e ajustar os produtos a serem encaminhados para enviá-los ao seu cliente e proporcionar uma melhor experiência.",

            },
            delivery_delay: {
                description: "Demora en entrega",
                recomendation: "Relembramos que pode duplicar a encomenda para enviar os seus produtos ao seu cliente e iniciar a devolução da encomenda com uma incidência para a devolver ao armazém caso seja recuperada.",

            },
            false_delivery: {
                description: "Entrega Incorrecta",
                recomendation: "Lembramos que pode duplicar a encomenda com incidência para fazer chegar os seus produtos ao seu cliente.",

            },
            package_stolen: {
                description: "Robo",
                recomendation: "Lembramos que você pode duplicar o pedido com um incidente para enviar ao seu cliente os produtos que ele pediu e proporcionar uma melhor experiência.",

            },
            delivery_others: {
                description: "Otros - Paquetería",
                recomendation: "",

            }
        },
        html: {
            rejected: {
                message_initial: "Tivemos que recusar a disputa do pedido",
                category: "categorizado como",
                apologies: "lamentamos o inconveniente.",
                reazon: "O motivo da rejeição é porque",
                evidence: "Anexado a este e-mail, compartilhamos as evidências que apoiam esta decisão.",
                recommendation: "Para proporcionar a melhor experiência possível ao seu cliente, recomendamos você",
                contact: "Você pode entrar em contato conosco pelo chat da plataforma se precisar de mais detalhes.",
                farewell: "Será um prazer atendê-lo",
                sender: "Cubbo"
            },
            accepted: {
                message_initial: "Aceitamos a disputa do pedido",
                category: "categorizado como",
                apologies: "lamentamos o inconveniente.",
                resolution: "Você verá o valor a ser reembolsado refletido em sua próxima fatura como um crédito a favor. Estes são os conceitos considerados para o reembolso:",
                contact: "Você pode entrar em contato conosco pelo chat da plataforma se precisar de mais detalhes.",
                farewell: "Será um prazer atendê-lo",
                sender: "Cubbo"
            }
        },
        status: {
            accepted: "Aceptado",
            rejected: "Rechazado"
        },
        messages: {
            none: "Nenhum",
            without_reason: "Sim motivo",
            success_message: "A disputa foi resolvida com sucesso",
            success_update_message: "A disputa foi atualizada.",
            error_message: "Erro ao salvar disputa",
        }
    },

    formatted_relative_time: {
        today: "Hoje",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        date: "{{day}} de {{month}}",
        from_now: "Há {{days}} dias"
    },

    orders: {
        filters: {
            order_number: "Número do pedido",
            paste_order_numbers: "Cole os números de os pedidos",
            paste_shipping_numbers: "Cole os números de os rastreamentos",
            shipping_number: "Etiqueta de envio",
            channel_name: "Canal de venda",
            shipping_method: "Método de envio",
            status: "Estado do pedido",
            shipping_status: "Estado de envio",
            shipping_date: "Data de envio",
            channel_name_placeholder: "Selecione um canal de venda",
            shipping_method_placeholder: "Selecione um método de envio",
            shipping_status_placeholder: "Selecione um estado de envio",
            shipping_incident_category_placeholder: "Qualquer tipo",
            shipping_incident_status_placeholder: "Qualquer estado",
            status_placeholder: "Selecione um estado",
            multifilter_bulk: "Pesquisa em pedido em massa ou rastreamento",
            store: "Loja",
            is_delayed: "Atrasados",
            first_delivery_on_time: "Tentativa de entrega no prazo",
            failed_delivery: "Entrega sem sucesso",
            shipping_incident: "Com incidente",
            without_shipping_incident: "Sem incidente",
            unsolved_shipping_incident: "Incidente não resolvido",
        },
        incidents_bar: {
            select_action: "Selecione uma ação",
            deselect_all_orders: "Desmarcar todos os pedidos",
            orders_selected: "Pedidos selecionados",
            update_incident: "Atualizar estado do incidente",
            update_shipping_status: "Atualizar estado de envio",
            update_current_status_for: "Atualizar estado atual para",
            update_current_shipping_status_for: "Atualizar estado de envio atual para",
            dialog: {
                create_title: "Tem certeza de que deseja criar incidente de",
                for: "para",
                orders_selected: "pedidos selecionados?",
                errors_intro: 'Pedidos para los cuales no es posible crear este incidente'
            }
        },
        incidents_container: {
            previous_delivery_date: "Data de entrega anterior",
            new_address: "Nova morada de entrega",
            address: "Endereço",
            number: "Número",
            neighborhood: "Bairro",
            city: "Cidade",
            zip_code: "CEP",
            state: "Estado"
        },
        list: {
            created_at: "Criado em",
            eta: "Entrega estimada",
            at: "El",
            create_incident: "Criar incidente",
            update_shipping_status: "Atualizar status de envio",
            sure_to_report: "Tem certeza de que deseja criar um incidente de ",
            requiring_monitoring: "Requerem monitoramento",
            no_information: "Sem Status",
            no_pieces: "Sem produtos para enviar",
        },
        shipping_incident: {
            status: {
                PENDING: "Pendente",
                IN_REVIEW: "Sob revisão",
                RESOLVED: "Resolvido",
            },
            category: {
                CANCELED: "Cancelamento solicitado",
                DELAYED: "Entrega atrasada",
                MISSING_REFERENCES: "Completar endereço",
                DAMAGED: 'Pedido avariado',
                MISSING_PRODUCT: 'Faltam produtos',
                FALSE_DELIVERY: 'Entrega incorreta',
                CHANGE_ADDRESS: "Alterar endereço",
                RESCHEDULE: "Reagendar data de entrega",
            },
            resolution: {
                STOLEN: 'Pedido roubado',
                LOST: 'Pedido extraviado',
                NON_REFUNDABLE_DAMAGED: 'Produto avariado não reembolsável',
                RETURNED: 'Retornou ao armazém',
                DELIVERED: 'Pedido entregue',
                REFUNDABLE: 'Reembolsável'
            },
            cant_update: 'Nenhum dos pedidos selecionados tem incidentes criados, então não há itens para atualizar',
            cant_create: {
                order_returned: "O pedido já foi devolvido",
                order_not_shipped_or_returning: "O pedido não foi enviado ou está em processo de devolução",
                unresolved_same_category_incident: "O pedido já tem um incidente deste tipo não resolvido",
                only_damaged_missing_product_false_delivery_incidents_allowed: "Somente incidentes de avaria, faltando produtos ou entrega incorreta são permitidos",
                only_delayed_canceled_missing_references_incidents_allowed: "Somente incidentes de atraso, cancelamento ou endereço incompleto são permitidos",
                remove_stock_order: "Este tipo de pedido não pode criar incidentes",
                temporarily_disabled: "Estamos trabalhando nisso, use o formulário",
            },
            errors: {
                create: {
                    INVALID_CATEGORY_FOR_ORDER_STATUS: 'A categoria de incidente não é válida para o estado do pedido',
                    ORDER_ALREADY_RETURNED: 'O pedido já foi devolvido',
                    ORDER_NOT_SHIPPED: 'O pedido não foi enviado',
                    UNRESOLVED_INCIDENT: 'O pedido já tem um incidente deste tipo não resolvido',
                    ERROR_DESCRIPTION_REQUIRED: 'A descrição do incidente é obrigatória',
                    ERROR_INCIDENT_ALREADY_RESOLVED: 'O incidente já foi resolvido',
                    ERROR_INCOMPATIBLE_ORDER: 'Este tipo de pedido não pode criar incidentes',
                    ORDER_HAS_RETURN: 'O Pedido já foi retornou ou retornando.',
                    ORDER_HAS_DELIVERY: 'O pedido já foi entregue.',
                    NO_INCIDENT_CREATED: 'O pedido não tem um incidente criado.'
                },
                error_modal: {
                    confirmations: {
                        CREATE_INCIDENT: 'Tem certeza de que deseja criar incidentes do tipo {incident_type} para {order_count} pedidos selecionados?',
                        UPDATE_SHIPPING_STATUS: 'Tem certeza de que deseja atualizar o status de envio {status} para {order_count} pedidos selecionados?',
                        RESOLVE_INCIDENT: 'Tem certeza de que deseja resolver incidentes para os {order_count} pedidos selecionados?',
                        UPDATE_SHIPPING_STATUS: 'Tem certeza de que deseja atualizar o status de envio {shipping_status} para os {order_count} pedidos selecionados?',
                        omit_errors_and_submit: 'Omitir e aceitar o resto',
                        no_valid_elements: 'Nenhum elemento válido.',
                    },
                    messages: {
                        action_not_possible: 'Detectamos {quantity} pedidos para os quais não é possível realizar esta ação',
                        omit_errors_and_submit_question: 'Deseja ignorar esses pedidos e aceitar o restante da seleção?',
                        order_labels_with_errors: 'Tracking dos pedidos com erros',
                        no_valid_elements_tooltip: 'Não é possível realizar esta ação para nenhum dos pedidos selecionados',
                    }
                }
            },
            pod: {
                download: "Baixar",
                received_by: "Recebido por",
                title: "Comprovante de entrega",
                not_provided: "Esta transportadora não fornece comprovante de entrega",
                unavailable: "Não temos comprovante de entrega para este pedido",
                proof: "Comprovante",
                download_success: "Comprovante de entrega baixado com sucesso",
                download_error: "Não foi possível baixar o comprovante de entrega, tente novamente mais tarde",
            },
        },
        show_shipping_incidents: {
            from_date: ". De ",
            created_by: {
                RECIPIENT: "Criado pelo comprador final ",
                CUBBO: "Criado pela Cubbo ",
            },
            info_types: {
                important: "Importante: "
            },
            toggle_description: {
                hide: "Ocultar ",
                show: "Mostrar "
            },
            description_title: {
                MISSING_REFERENCES: "endereço compartilhado",
                OTHER: "evidência compartilhada",
            },
            categories: {
                DELAYED: "Incidente: Atraso na entrega",
                MISSING_REFERENCES: "Incidente: Complementar endereço",
                CANCELED: "Incidente: Cancelar entrega",
                DAMAGED: "Incidente: Produto danificado",
                MISSING_PRODUCT: "Incidente: Produtos faltando",
                FALSE_DELIVERY: "Incidente: Entrega incorreta",
                CHANGE_ADDRESS: "Incidente: Alterar endereço",
                RESCHEDULE: "Incidente: Reagendar data de entrega",
            },

            status: {
                PENDING: "Pendente",
                IN_REVIEW: "Em revisão",
                RESOLVED: "Resolvido"
            },

            evidence_type: {
                product_images: "Fotos detalhadas do incidente.",
                label_images: "Fotos da etiqueta de envio.",
                package_images: "Fotos da embalagem."
            }
        },
        packing_material: {
            BUBBLE_WRAP: "Plástico bolha",
            KRAFT_PAPER: "Papel Kraft",
            CORN_EXTRUDATE: "Extrusado de milho"
        }
    },

    cubbo_lastmile_events: {
        order_events: "Histórico",
        created_email: "Por {{user_email}}",
        created_email_xdock: "Por {{user_email}} em {{xdock_name}}",
        no_events: "Não existem eventos disponíveis",
        errors: "Conflito registrado: {{error_codes}}",
        is_collapsed: "Ver tudo",
        is_not_collapsed: "Recolher",
        event_types: {
            CREATED_LABEL: "Guia gerada",
            RECEIVED_AT_XDOCK: "Recebido no Xdock",
            ASSIGN_ROUTE: "Rota atribuída",
            CREATED_DELIVERY_ROUTE: "Rota de entrega gerada",
            GROUPING_PACKAGES: "Empacotamento guia",
            GROUPED_PACKAGES: "Guia empacotada",
            DISPATCHED_TO_MIDDLE_MILE: "Despachado para Middle Mile",
            MIDDLE_MILE_IN_TRANSIT: "Em trânsito pelo Middle Mile",
            DISPATCHED_FOR_DELIVERY: "Despachado para motorista",
            IN_DELIVERY: "Em rota de entrega",
            DELIVERED: "Entregue",
            SHIPPING_INCIDENT: "Incidente",
            FAILED_DELIVERY_ATTEMPT: "Tentativa de entrega falhou",
            RESCHEDULED_DELIVERY: "Entrega reprogramada",
            CANCELLED: "Cancelado",
            RETURNING: "Retornando",
            DISPATCHED_TO_XDOCK: "Despachado para Xdock",
            RETURNED: "Retornado",
            LOST: "Pacote reportado como perdido",
            DAMAGED: "Pacote reportado como danificado",
            STOLEN: "Pacote reportado como roubado",
            SHIPPING_INCIDENT_DELAYED: "Incidente: Atraso na entrega",
            SHIPPING_INCIDENT_MISSING_REFERENCES: "Incidente: Complementar endereço",
            SHIPPING_INCIDENT_MISSING_PRODUCT: "Incidente: Produto faltante",
            SHIPPING_INCIDENT_FALSE_DELIVERY: "Incidente: Entrega incorreta",
            SHIPPING_INCIDENT_CHANGE_ADDRESS: "Incidente: Alterar endereço",
            DISPATCHED_TO_WAREHOUSE: "Despachado para armazém",
            INVALID_LABEL: "Guia inválida",
            PACKAGING_LABEL: "Guia embalada",
            UNPACKED_LABEL: "Guia desembalada",
            PACKED_LABEL: "Guia empacotada"
        },
        error_codes: {
            LABEL_NOT_FOUND: "Guia não encontrada",
            LABEL_WRONG_CARRIER: "Transportadora incorreta",
            LABEL_INVALID_STATUS: "Guia com status incorreto",
            WRONG_OPERATION: "Operação incorreta",
            WRONG_ROUTE: "Rota incorreta",
            NO_ROUTE: "Sem rota",
            CANCELLED: "Pedido cancelado",
            PROCESS_REVERSE_LOGISTICS: "Processando logística reversa",
            REPROGRAMMED: "Entrega reprogramada",
            WRONG_STATUS: "Status incorreto",
            INCIDENT_LOST: "Incidente: Perdido",
            INCIDENT_DAMAGED: "Incidente: Danificado",
            INCIDENT_STOLEN: "Incidente: Roubado",
            LABEL_NOT_RECEIVED: "Guia não recebida no Xdock",
        }
    },

    returns: {
        unidentified: "Não identificado",
        errors: {
            not_belong_to_warehouse: "O retorno da ordem #{{order_number}} pertence ao armazém '{{warehouse_name}}', !SEPARA¡ para processá-lo no armazém correto.",
        },
        return_types: {
            unknown: "Desconhecido",
            simple_return: "Devolução",
            exchange: "Troca",
            immediate_exchange: "Troca imediata",
            returned_by_carrier: "Paquetería",
            unidentified: "Não identificado",
        }

    },

    generic: {
        order: "Pedido",
        orders: "Pedidos",
        error: "Erro",
        store: "Loja",
        warehouse: "Armazém",
        country: "País",
        status: "Estado",
        from: "De",
        to: "Até",
        usages: "Usos",
        billing_statements: "Cobranças",
        empty_table: "Sem dados para mostrar",
        undefined: "Não definido",
        active: "Ativo",
        pending: "Pendente",
        disabled: "Desativado",
        not_having_current_billing_configuration: "Sem configuração de faturamento",
        having_current_billing_configuration: "Com configuração de faturamento",
        store: "Loja",
        stores: "Lojas",
        store_name: "Nome da loja",
    },

    access_denied: "Desculpe, você não tem permissão para acessar esta página",
    filter: {
        button: "Filtrar",
        reset: "Limpar filtros",
        apply: "Aplicar filtros",
        select: "Selecione um estado",
        from_to: "de-até",
        export: "Exportar",
        in: 'em'
    },

    dialog: {
        yes: "Sim",
        no: 'Não'
    },
    statuses: {
        order_statuses: {
            unknow: "STATUS_NO_DEF",
            initial: "Sincronizando",
            empty: "Pedido vazio",
            pending: "Pendente",
            processing: "Processando",
            shipped: "Enviado",
            returning: "Em devolução a Cubbo",
            returned: "Devolução recebida",
            canceled: "Cancelado",
            error: "Informação Pendente",
            entirely_dropshipping: "Dropshipping",
            backorder: "Sem Estoque",
            unpaid: "Pagamento pendente",
            cancelation_window: "Janela de Cancelamento",
            hold: "Pausado",
            interrupted: "Interrompido",
            waiting_pick_up: "Aguardando coleta",
            awaiting_pick_up: "Retirada pendente",
            picked_up: "Coletado",
            in_warehouse: "Recebido em armazém",
            delayed: "Atrasado",
        },
        tracking_statuses: {
            unknown: "Sem Status",
            in_transit: "Em trânsito",
            shipment_delivered: "Entrega Realizada",
            shipment_with_incident: 'Incidente',
            shipment_canceled: 'Entrega Cancelada',
            shipment_to_be_self_collected: 'Retire no escritório',
            shipment_out_for_delivery: 'Na rota de entrega',
            shipment_with_incident_lost: 'Incidente: Perdido',
            shipment_with_incident_stolen: 'Incidente: Roubado',
            shipment_with_incident_damaged: 'Incidente: Danificado',
            delayed: 'Atrasado',
            shipping_returned: "Devolvido para envio"
        },
        returns_statuses: {
            unknow: "Sem status",
            requested: "Aguardando retorno",
            pending: "Decisão pendente",
            cancelled: "Reenvio cancelado",
            ordered: "Reenvio solicitado",
            received: "Recebendo retorno",
            arrived_at_warehouse: "Chegou ao armazém",
            reentered: "Retorno reingressado",
        },

        tracking_descriptions: {
            second_try: 'Segunda tentativa',
            third_try: 'Terceira tentativa',
            client_requested: 'Solicitação do comprador',
            missing_references: 'Referências ausentes',
            not_at_home: 'O comprador estava ausente',
            refused_payment: 'O comprador se recusou a pagar',
            refused_package: 'O comprador recusou o pacote',
            cubbo_requested: 'Solicitação do Cubbo',
            carrier_requested: 'Solicitação de operadora',
            stolen: 'Roubaram',
            lost: 'Perda',
            damaged: 'Danificado',
            returned_by_carrier: 'Por entrega sem sucesso',
            returned_by_client: 'Por devolução solicitada',
            in_return: "Em devolução pela transportadora",
        }
    },
    billing: {
        copy_config_filter: "Selecione a loja da qual você deseja copiar a configuração",
        copy_config_duplicate: "Digite o nome da loja da qual deseja duplicar a configuração",
        copy_config_results: "Os primeiros 5 resultados são exibidos, refine sua pesquisa para encontrar a loja desejada",
        copy_config: "Copiar configuração de outra loja",
        create_error_title: "Ocorreu um erro, tente novamente mais tarde",
        create_invalid_content_error_title: "Complete as informações necessárias e/ou corrija para poder criar a configuração de cobrança",
        from_prefix: "Mais de ",
        title: "Cobrança",
        continue: "Continuar",
        save: "Finalizar e salvar configuração",
        create: "Criar configuração",
        disable: "Desativar",
        duplicate: "Duplicar",
        disable_title: "Desativar cobrança no corte",
        already_disabled: "A configuração de cobrança já foi desativada",
        billing_configurations_history: "Histórico de configurações de cobrança",
        billing_custom_services: "Cobranças/Descontos adicionais",
        disable_billing_for_store_success: "A configuração de cobrança será desativada no próximo corte",
        status: {
            ACTIVE: "Ativo",
            DISABLED: "Desativado",
            UNREQUIRED: "Não requerido",
            PENDING: "Pendente"
        },
        stores: {
            start_date: "Início da vigência",
            end_date: "Próximo corte",
            empty: "Não há Lojas para mostrar.",
            about: "Sobre a loja",
            no_data: "Sem informações",
            configure: "Configurar tarifas de cobrança",
            next_cutoff_at: "Data do corte",
            due_next_week: "Vence na próxima semana",
        },
        save_dialog: {
            title: "Criar configuração de cobrança",
            description: "Confirme a criação da configuração de cobrança",
            confirm_button: "Confirmar",
            cancel_button: "Cancelar"
        },
        confirm_disable_dialog: {
            title: "Desativar no próximo corte",
            description: "Confirme a desativação da configuração de cobrança no próximo corte",
            confirm: "Confirmar",
            cancel: "Cancelar"
        },
        confirm_exit_dialog: {
            title: "As alterações serão descartadas. Deseja continuar?"
        },
        tabTitles: {
            billing_date: "Data de faturamento",
            storage: "Armazenamento",
            pick_and_pack: "Pick and Pack",
            shipping_label: "Envios nacionais",
            international_shipping_label: "Envios internacionais",
            replenishment: "Recebimento de inventário",
            returns: "Retornos",
            work_orders: "Maquilas",
            difal: "Difal",
            shipping_insurance: "Seguro de envio",
            packing_material: "Materiais de embalagem"
        },
        ongoing: "Em andamento",
        billed: "Anterior",
        future: "Futura",
        duplicate_configuration: "Duplicar configuração de cobrança",
        show_configuration: "Ver configuração de cobrança",
        store_billing_config: {
            cutoff_interval: {
                title: "Frequência do corte",
                options: {
                    YEAR: "Anual",
                    MONTH: "Mensal",
                    WEEK: "Semanal"
                }
            }
        },
        range_billing_price_config_table: {
            errors: {
                MISSING_FROM_VALUE: "Insira um valor",
                MISSING_TO_VALUE: "Insira um valor",
                MISSING_PRICE_VALUE: "Insira um preço",
                MISSING_UNIT_VALUE: "Selecione uma unidade",
                FROM_IS_GREATER_THAN_TO: "'Deve ser menor que 'Até'",
                FROM_AND_TO_ARE_EQUAL: "'Deve ser menor que 'Até'",
                EXCESS_IS_ONLY_ALLOWED_AT_END: "'Excesso' só pode ser o último elemento",
                MISSING_PRICE_MODE: "",
                INVALID_UNIT_VALUE: "Selecione uma unidade"
            },
            unit_options: {
                PER_UNIT: "Cobrança por peça",
                TOTAL: "Cobrança total",
                EXCESS_PER_UNIT: "Cobrança extra por peça excedida",
                EXCESS_TOTAL: "Cobrança extra fixa por excesso"
            },
            last_row_placeholder: "Sem limite"
        },
        table_headers: {
            from_piece: "De peça",
            to_piece: "Até peça",
            from_weight: "De kg",
            to_weight: "Até kg",
            price: "Preço",
            percentage: "Porcentagem",
            unit: "Unidade de cobrança",
            package: "Pacote",
            packing_material: "Material de embalagem",
            location_type: "Tipo de localização",
            tariff: "Tarifa por localização",
            NORTH_AMERICA: "Preço América do Norte",
            LATIN_AMERICA: "Preço América Latina",
            CARIBBEAN: "Preço Caribe",
            EUROPE: "Preço Europa",
            ASIA: "Preço Ásia",
            AFRICA: "Preço África"
        },
        pick_and_pack_services: {
            picking_title: "Picking",
            insert_title: "Itens promocionais",
            serial_number_title: "Controle de saída por número de série",
            fragile_title: "Embalagem de pacote frágil",
            packages_title: "Embalagens",
            package_title: {
                parcel_bag: "Saco de encomenda",
                jiffy_envelope: "Envelope Jiffy",
                cubbo_box: "Caixa Cubbo",
                customer_box: "Caixa do cliente"
            },
            picking_unit_options: {
                PER_UNIT: "Cobrança por peça",
                TOTAL: "Cobrança por pedido",
                EXCESS_PER_UNIT: "Cobrança extra por peça excedida",
                EXCESS_TOTAL: "Cobrança extra fixa por excesso"
            },
            package_unit_options: {
                TOTAL: "Cobrança por pacote",
            },
            fragile_picking_unit_options: {
                TOTAL: "Cobrança por pacote",
            }
        },
        billing_storage_table: {
            STORAGE_BY_LOCATION: "Cobrança por localização",
            STORAGE_BY_PRODUCT: "Cobrança por peça armazenada",
            missing_picking_standard_error: "ERRO: Localização PICKING STANDARD inexistente",
            category_codes: {
                PICKING_STANDARD: "Regular",
                LOST: "Perdidos",
                DAMAGED: "Danificados",
                PALLET: "Palete",
                RECEPTION: "Recepção",
                PRESALE: "Pré-venda",
                RELOCATION: "Recolocação",
                OFF_PREMISES: "Fora do local",
                PICKING_MINIBIN: "Picking minibin"
            },
            calculated_tariff_tooltip: "Valor calculado com base no preço definido da localização regular",
            tariff_error_message: "Insira a tarifa",
            units: "localização/mês"
        },
        billing_stroage_table_by_unit: {
            unit_options: {
                PER_UNIT: "Cobrança por peça armazenada",
            },
        },
        replenishment_services: {
            replenishment_title: "Recebimento de peças regulares",
            replenishment_lots_title: "Recebimento de peças com controle de lote",
            unit_options: {
                PER_UNIT: "Cobrança por peça recebida",
                TOTAL: "Cobrança por recebimento",
                EXCESS_PER_UNIT: "Cobrança extra por peça excedida",
                EXCESS_TOTAL: "Cobrança extra fixa por excesso"
            },
        },
        difal_services: {
            difal_title: "Difal",
            unit_options: {
                TOTAL: "Cobrança por pedido"
            },
        },
        shipping_insurance_services: {
            shipping_insurance_title: "Seguro de envio",
            unit_options: {
                TOTAL: "Cobrança por pedido"
            },
        },
        packing_material_services: {
            packing_material_title: "Materiais de empacotamiento",
            packing_material_codes: {
                BUBBLE_WRAP: "Plástico bolha",
                CORN_EXTRUDATE: "Extrusado de milho",
                KRAFT_PAPER: "Papel Kraft"
            },
            unit_options: {
                TOTAL: "Cobrança por pacote"
            },
        },
        return_services: {
            return_order_title: "Recebimento de peças regulares",
            return_order_lots_title: "Recebimento de peças com controle de lote",
            return_shipping_label_title: "Guias de retorno",
            unit_options: {
                PER_UNIT: "Cobrança por peça recebida",
                TOTAL: "Cobrança por recebimento",
                EXCESS_PER_UNIT: "Cobrança extra por peça excedida",
                EXCESS_TOTAL: "Cobrança extra fixa por excesso"
            },
            return_label_unit_options: {
                TOTAL: "Cobrança por guia",
                EXCESS_PER_UNIT: "Cobrança extra por quilo excedido",
            },
        },
        work_orders_services: {
            work_order_title: "Maquilas",
            unit_options: {
                PER_UNIT: "Cobrança por pessoa/dia"
            }
        },
        national_shipping_label_services: {
            titles: {
                SUPER_SAVER: "Super saver",
                LOCAL: "Local",
                PREMIUM: "Premium",
                ECONOMY: "Econômico",
                PICKUP: "Recolhimento no depósito",
                GROUND_SP_CAP: "Ground SP Capital",
                GROUND_SP_INT: "Ground SP Interior",
                GROUND_RJ_CAP: "Ground RJ Capital",
                GROUND_RJ_INT: "Ground RJ Interior",
                GROUND_ES_CAP: "Ground ES Capital",
                GROUND_ES_INT: "Ground ES Interior",
                GROUND_MG_CAP: "Ground MG Capital",
                GROUND_MG_INT: "Ground MG Interior",
                GROUND_BA_CAP: "Ground BA Capital",
                GROUND_BA_INT: "Ground BA Interior",
                GROUND_SE_CAP: "Ground SE Capital",
                GROUND_SE_INT: "Ground SE Interior",
                GROUND_PE_CAP: "Ground PE Capital",
                GROUND_PE_INT: "Ground PE Interior",
                GROUND_AL_CAP: "Ground AL Capital",
                GROUND_AL_INT: "Ground AL Interior",
                GROUND_PB_CAP: "Ground PB Capital",
                GROUND_PB_INT: "Ground PB Interior",
                GROUND_RN_CAP: "Ground RN Capital",
                GROUND_RN_INT: "Ground RN Interior",
                GROUND_CE_CAP: "Ground CE Capital",
                GROUND_CE_INT: "Ground CE Interior",
                GROUND_PI_CAP: "Ground PI Capital",
                GROUND_PI_INT: "Ground PI Interior",
                GROUND_MA_CAP: "Ground MA Capital",
                GROUND_MA_INT: "Ground MA Interior",
                GROUND_PA_CAP: "Ground PA Capital",
                GROUND_PA_INT: "Ground PA Interior",
                GROUND_AP_CAP: "Ground AP Capital",
                GROUND_AP_INT: "Ground AP Interior",
                GROUND_AM_CAP: "Ground AM Capital",
                GROUND_AM_INT: "Ground AM Interior",
                GROUND_RR_CAP: "Ground RR Capital",
                GROUND_RR_INT: "Ground RR Interior",
                GROUND_AM_INT_2: "Ground AM Interior 2",
                GROUND_AC_CAP: "Ground AC Capital",
                GROUND_AC_INT: "Ground AC Interior",
                GROUND_DF_CAP: "Ground DF Capital",
                GROUND_DF_INT: "Ground DF Interior",
                GROUND_GO_CAP: "Ground GO Capital",
                GROUND_DF_INT_2: "Ground DF Interior 2",
                GROUND_GO_CAP_2: "Ground GO Capital 2",
                GROUND_GO_INT: "Ground GO Interior",
                GROUND_RO_CAP: "Ground RO Capital",
                GROUND_RO_INT: "Ground RO Interior",
                GROUND_TO_CAP: "Ground TO Capital",
                GROUND_TO_INT: "Ground TO Interior",
                GROUND_MT_CAP: "Ground MT Capital",
                GROUND_MT_INT: "Ground MT Interior",
                GROUND_RO_INT_2: "Ground RO Interior 2",
                GROUND_RO_INT_3: "Ground RO Interior 3",
                GROUND_MS_CAP: "Ground MS Capital",
                GROUND_MS_INT: "Ground MS Interior",
                GROUND_PR_CAP: "Ground PR Capital",
                GROUND_PR_INT: "Ground PR Interior",
                GROUND_SC_CAP: "Ground SC Capital",
                GROUND_SC_INT: "Ground SC Interior",
                GROUND_RS_CAP: "Ground RS Capital",
                GROUND_RS_INT: "Ground RS Interior",
                /*
                EXPRESS_SP_CAP: "Express SP Capital",
                EXPRESS_SP_INT: "Express SP Interior",
                EXPRESS_RJ_CAP: "Express RJ Capital",
                EXPRESS_RJ_INT: "Express RJ Interior",
                EXPRESS_ES_CAP: "Express ES Capital",
                EXPRESS_ES_INT: "Express ES Interior",
                EXPRESS_MG_CAP: "Express MG Capital",
                EXPRESS_MG_INT: "Express MG Interior",
                EXPRESS_BA_CAP: "Express BA Capital",
                EXPRESS_BA_INT: "Express BA Interior",
                EXPRESS_SE_CAP: "Express SE Capital",
                EXPRESS_SE_INT: "Express SE Interior",
                EXPRESS_PE_CAP: "Express PE Capital",
                EXPRESS_PE_INT: "Express PE Interior",
                EXPRESS_AL_CAP: "Express AL Capital",
                EXPRESS_AL_INT: "Express AL Interior",
                EXPRESS_PB_CAP: "Express PB Capital",
                EXPRESS_PB_INT: "Express PB Interior",
                EXPRESS_RN_CAP: "Express RN Capital",
                EXPRESS_RN_INT: "Express RN Interior",
                EXPRESS_CE_CAP: "Express CE Capital",
                EXPRESS_CE_INT: "Express CE Interior",
                EXPRESS_PI_CAP: "Express PI Capital",
                EXPRESS_PI_INT: "Express PI Interior",
                EXPRESS_MA_CAP: "Express MA Capital",
                EXPRESS_MA_INT: "Express MA Interior",
                EXPRESS_PA_CAP: "Express PA Capital",
                EXPRESS_PA_INT: "Express PA Interior",
                EXPRESS_AP_CAP: "Express AP Capital",
                EXPRESS_AP_INT: "Express AP Interior",
                EXPRESS_AM_CAP: "Express AM Capital",
                EXPRESS_AM_INT: "Express AM Interior",
                EXPRESS_RR_CAP: "Express RR Capital",
                EXPRESS_RR_INT: "Express RR Interior",
                EXPRESS_AM_INT_2: "Express AM Interior 2",
                EXPRESS_AC_CAP: "Express AC Capital",
                EXPRESS_AC_INT: "Express AC Interior",
                EXPRESS_DF_CAP: "Express DF Capital",
                EXPRESS_DF_INT: "Express DF Interior",
                EXPRESS_GO_CAP: "Express GO Capital",
                EXPRESS_DF_INT_2: "Express DF Interior 2",
                EXPRESS_GO_CAP_2: "Express GO Capital 2",
                EXPRESS_GO_INT: "Express GO Interior",
                EXPRESS_RO_CAP: "Express RO Capital",
                EXPRESS_RO_INT: "Express RO Interior",
                EXPRESS_TO_CAP: "Express TO Capital",
                EXPRESS_TO_INT: "Express TO Interior",
                EXPRESS_MT_CAP: "Express MT Capital",
                EXPRESS_MT_INT: "Express MT Interior",
                EXPRESS_RO_INT_2: "Express RO Interior 2",
                EXPRESS_RO_INT_3: "Express RO Interior 3",
                EXPRESS_MS_CAP: "Express MS Capital",
                EXPRESS_MS_INT: "Express MS Interior",
                EXPRESS_PR_CAP: "Express PR Capital",
                EXPRESS_PR_INT: "Express PR Interior",
                EXPRESS_SC_CAP: "Express SC Capital",
                EXPRESS_SC_INT: "Express SC Interior",
                EXPRESS_RS_CAP: "Express RS Capital",
                EXPRESS_RS_INT: "Express RS Interior"
                */
            },
            extended_zone_titles: {
                SUPER_SAVER: "Zona estendida Super saver",
                LOCAL: "Zona estendida Local",
                PREMIUM: "Zona estendida Premium",
                ECONOMY: "Zona estendida Econômica",
                GROUND_SP_CAP: "Zona estendida Ground SP Capital",
                GROUND_SP_INT: "Zona estendida Ground SP Interior",
                GROUND_RJ_CAP: "Zona estendida Ground RJ Capital",
                GROUND_RJ_INT: "Zona estendida Ground RJ Interior",
                GROUND_ES_CAP: "Zona estendida Ground ES Capital",
                GROUND_ES_INT: "Zona estendida Ground ES Interior",
                GROUND_MG_CAP: "Zona estendida Ground MG Capital",
                GROUND_MG_INT: "Zona estendida Ground MG Interior",
                GROUND_BA_CAP: "Zona estendida Ground BA Capital",
                GROUND_BA_INT: "Zona estendida Ground BA Interior",
                GROUND_SE_CAP: "Zona estendida Ground SE Capital",
                GROUND_SE_INT: "Zona estendida Ground SE Interior",
                GROUND_PE_CAP: "Zona estendida Ground PE Capital",
                GROUND_PE_INT: "Zona estendida Ground PE Interior",
                GROUND_AL_CAP: "Zona estendida Ground AL Capital",
                GROUND_AL_INT: "Zona estendida Ground AL Interior",
                GROUND_PB_CAP: "Zona estendida Ground PB Capital",
                GROUND_PB_INT: "Zona estendida Ground PB Interior",
                GROUND_RN_CAP: "Zona estendida Ground RN Capital",
                GROUND_RN_INT: "Zona estendida Ground RN Interior",
                GROUND_CE_CAP: "Zona estendida Ground CE Capital",
                GROUND_CE_INT: "Zona estendida Ground CE Interior",
                GROUND_PI_CAP: "Zona estendida Ground PI Capital",
                GROUND_PI_INT: "Zona estendida Ground PI Interior",
                GROUND_MA_CAP: "Zona estendida Ground MA Capital",
                GROUND_MA_INT: "Zona estendida Ground MA Interior",
                GROUND_PA_CAP: "Zona estendida Ground PA Capital",
                GROUND_PA_INT: "Zona estendida Ground PA Interior",
                GROUND_AP_CAP: "Zona estendida Ground AP Capital",
                GROUND_AP_INT: "Zona estendida Ground AP Interior",
                GROUND_AM_CAP: "Zona estendida Ground AM Capital",
                GROUND_AM_INT: "Zona estendida Ground AM Interior",
                GROUND_AM_INT_2: "Zona estendida Ground AM Interior 2",
                GROUND_RR_CAP: "Zona estendida Ground RR Capital",
                GROUND_RR_INT: "Zona estendida Ground RR Interior",
                GROUND_AC_CAP: "Zona estendida Ground AC Capital",
                GROUND_AC_INT: "Zona estendida Ground AC Interior",
                GROUND_DF_CAP: "Zona estendida Ground DF Capital",
                GROUND_DF_INT: "Zona estendida Ground DF Interior",
                GROUND_DF_INT_2: "Zona estendida Ground DF Interior 2",
                GROUND_GO_CAP: "Zona estendida Ground GO Capital",
                GROUND_GO_CAP_2: "Zona estendida Ground GO Capital 2",
                GROUND_GO_INT: "Zona estendida Ground GO Interior",
                GROUND_RO_CAP: "Zona estendida Ground RO Capital",
                GROUND_RO_INT: "Zona estendida Ground RO Interior",
                GROUND_RO_INT_2: "Zona estendida Ground RO Interior 2",
                GROUND_RO_INT_3: "Zona estendida Ground RO Interior 3",
                GROUND_TO_CAP: "Zona estendida Ground TO Capital",
                GROUND_TO_INT: "Zona estendida Ground TO Interior",
                GROUND_MT_CAP: "Zona estendida Ground MT Capital",
                GROUND_MT_INT: "Zona estendida Ground MT Interior",
                GROUND_MS_CAP: "Zona estendida Ground MS Capital",
                GROUND_MS_INT: "Zona estendida Ground MS Interior",
                GROUND_PR_CAP: "Zona estendida Ground PR Capital",
                GROUND_PR_INT: "Zona estendida Ground PR Interior",
                GROUND_SC_CAP: "Zona estendida Ground SC Capital",
                GROUND_SC_INT: "Zona estendida Ground SC Interior",
                GROUND_RS_CAP: "Zona estendida Ground RS Capital",
                GROUND_RS_INT: "Zona estendida Ground RS Interior",
                /*
                EXPRESS_SP_CAP: "Zona estendida Express SP Capital",
                EXPRESS_SP_INT: "Zona estendida Express SP Interior",
                EXPRESS_RJ_CAP: "Zona estendida Express RJ Capital",
                EXPRESS_RJ_INT: "Zona estendida Express RJ Interior",
                EXPRESS_ES_CAP: "Zona estendida Express ES Capital",
                EXPRESS_ES_INT: "Zona estendida Express ES Interior",
                EXPRESS_MG_CAP: "Zona estendida Express MG Capital",
                EXPRESS_MG_INT: "Zona estendida Express MG Interior",
                EXPRESS_BA_CAP: "Zona estendida Express BA Capital",
                EXPRESS_BA_INT: "Zona estendida Express BA Interior",
                EXPRESS_SE_CAP: "Zona estendida Express SE Capital",
                EXPRESS_SE_INT: "Zona estendida Express SE Interior",
                EXPRESS_PE_CAP: "Zona estendida Express PE Capital",
                EXPRESS_PE_INT: "Zona estendida Express PE Interior",
                EXPRESS_AL_CAP: "Zona estendida Express AL Capital",
                EXPRESS_AL_INT: "Zona estendida Express AL Interior",
                EXPRESS_PB_CAP: "Zona estendida Express PB Capital",
                EXPRESS_PB_INT: "Zona estendida Express PB Interior",
                EXPRESS_RN_CAP: "Zona estendida Express RN Capital",
                EXPRESS_RN_INT: "Zona estendida Express RN Interior",
                EXPRESS_CE_CAP: "Zona estendida Express CE Capital",
                EXPRESS_CE_INT: "Zona estendida Express CE Interior",
                EXPRESS_PI_CAP: "Zona estendida Express PI Capital",
                EXPRESS_PI_INT: "Zona estendida Express PI Interior",
                EXPRESS_MA_CAP: "Zona estendida Express MA Capital",
                EXPRESS_MA_INT: "Zona estendida Express MA Interior",
                EXPRESS_PA_CAP: "Zona estendida Express PA Capital",
                EXPRESS_PA_INT: "Zona estendida Express PA Interior",
                EXPRESS_AP_CAP: "Zona estendida Express AP Capital",
                EXPRESS_AP_INT: "Zona estendida Express AP Interior",
                EXPRESS_AM_CAP: "Zona estendida Express AM Capital",
                EXPRESS_AM_INT: "Zona estendida Express AM Interior",
                EXPRESS_AM_INT_2: "Zona estendida Express AM Interior 2",
                EXPRESS_RR_CAP: "Zona estendida Express RR Capital",
                EXPRESS_RR_INT: "Zona estendida Express RR Interior",
                EXPRESS_AC_CAP: "Zona estendida Express AC Capital",
                EXPRESS_AC_INT: "Zona estendida Express AC Interior",
                EXPRESS_DF_CAP: "Zona estendida Express DF Capital",
                EXPRESS_DF_INT: "Zona estendida Express DF Interior",
                EXPRESS_DF_INT_2: "Zona estendida Express DF Interior 2",
                EXPRESS_GO_CAP: "Zona estendida Express GO Capital",
                EXPRESS_GO_CAP_2: "Zona estendida Express GO Capital 2",
                EXPRESS_GO_INT: "Zona estendida Express GO Interior",
                EXPRESS_RO_CAP: "Zona estendida Express RO Capital",
                EXPRESS_RO_INT: "Zona estendida Express RO Interior",
                EXPRESS_RO_INT_2: "Zona estendida Express RO Interior 2",
                EXPRESS_RO_INT_3: "Zona estendida Express RO Interior 3",
                EXPRESS_TO_CAP: "Zona estendida Express TO Capital",
                EXPRESS_TO_INT: "Zona estendida Express TO Interior",
                EXPRESS_MT_CAP: "Zona estendida Express MT Capital",
                EXPRESS_MT_INT: "Zona estendida Express MT Interior",
                EXPRESS_MS_CAP: "Zona estendida Express MS Capital",
                EXPRESS_MS_INT: "Zona estendida Express MS Interior",
                EXPRESS_PR_CAP: "Zona estendida Express PR Capital",
                EXPRESS_PR_INT: "Zona estendida Express PR Interior",
                EXPRESS_SC_CAP: "Zona estendida Express SC Capital",
                EXPRESS_SC_INT: "Zona estendida Express SC Interior",
                EXPRESS_RS_CAP: "Zona estendida Express RS Capital",
                EXPRESS_RS_INT: "Zona estendida Express RS Interior"
                */
            },
            unit_options: {
                TOTAL: "Cobrança por guia",
                EXCESS_PER_UNIT: "Cobrança extra por quilo excedido",
            },
            pickup_unit_options: {
                TOTAL: "Cobrança por pedido",
            }
        },
        international_shipping_label_services: {
            unit_options: {
                TOTAL: "Cobrança por guia",
                EXCESS_PER_UNIT: "Cobrança extra por quilo excedido"
            }
        },
        custom_services: {
            create_current_title: "Criar cobrança/desconto adicional para o corte atual",
            create_button: "Criar cobrança/desconto adicional",
            types: {
                discount: "Desconto",
                charge: "Cobrança"
            },
            no_services: "Sem informações",
            create_custom_service: {
                init_error: "Ocorreu um erro ao inicializar, tente novamente mais tarde",
                create_error: "Ocorreu um erro durante a criação, tente novamente mais tarde",
                store_name: "Loja: ",
                warehouse_name: "Depósito: ",
                is_discount: "É desconto?",
                title: "Título",
                title_placeholder: "Insira um título",
                description: "Descrição",
                description_placeholder: "Insira uma descrição",
                amount_discount: "Valor do desconto",
                amount_placeholder_discount: "Insira um valor de desconto",
                amount_charge: "Valor da cobrança",
                amount_placeholder_charge: "Insira um valor de cobrança",
                no_amount: "O valor não pode ser 0",
                create_button: "Criar serviço personalizado",
                remaining_text_length: "Caracteres restantes disponíveis: ",
                confirm_create_dialog: {
                    title_DISCOUNT: "Criar desconto adicional",
                    title_CHARGE: "Criar cobrança adicional",
                    description_DISCOUNT: "Confirme a criação do desconto adicional para a loja {STORE_NAME} no depósito {WAREHOUSE_NAME}",
                    description_CHARGE: "Confirme a criação da cobrança adicional para a loja {STORE_NAME} no depósito {WAREHOUSE_NAME}",
                    confirm_button: "Confirmar",
                    cancel_button: "Cancelar"
                }
            },
            list_custom_services: {
                table_columns: {
                    id: "ID",
                    billed_total_price: "Valor",
                    type: "Tipo",
                    title: "Título",
                    description: "Descrição"
                },
                init_error: "Ocorreu um erro ao inicializar, tente novamente mais tarde",
                table_filters: {
                    title: "Título",
                    title_placeholder: "Buscar por título",
                    billed_total_price: "Valor",
                    greater_or_equal_than_billed_total_price: "Maior ou igual ao valor",
                    less_or_equal_than_billed_total_price: "Menor ou igual ao valor",
                    is_discount: "É desconto",
                    is_charge: "É cobrança",
                    description: "Descrição"
                }
            }
        }
    },
    work_orders: {
        work_order_details: {
            work_orders: "Maquilas",
            work_order_details: "Detalhes da solicitação de maquila",
            work_order_number: "Nº de maquila",
            solicitant: "Solicitante",
            work_order_status: "Estado da maquila",
            on_date: "Em",
            comments_to_the_brand: "Comentários para a marca",
            next_status: "Ao salvar os dados, o estado da maquila será atualizado para",
            processing_work_order: "Processando maquila",
            product_origin: "Origem do material necessário",
            rem_order: "Retirada de inventário",
            no_rem_order: "Esta maquila não possui pedido de retirada de inventário",
            work_order: "Solicitação de maquila",
            work_order_type: "Tipo de processo",
            notes: "Notas",
            instruction: "Instrução",
            activity: "Atividade",
            replenishment: "Entrada de produto maquilado",
            replenishment_id: "Recibo de inventário de produto maquilado",
            replenishment_note: "A partir deste recibo de inventário, você pode acompanhar o progresso da entrada do produto maquilado em seu inventário",
            resolve_order: "Resolver solicitação",
            notification_message: {
                success_update_message: "Estado da maquila atualizado com sucesso",
                error_update_message: "Erro ao atualizar estado da maquila"
            },
            work_order_statuses: {
                REQUESTED: "Solicitada",
                IN_VALIDATION: "Em validação",
                SCHEDULED: "Próxima a iniciar",
                IN_PROGRESS: "Em progresso",
                COMPLETED: "Completada",
                REJECTED: "Rejeitada",
                CANCELED: "Cancelada"
            },
            work_order_types: {
                LABELING_PLASTISEAL: "De etiquetagem ou plastificação",
                PRODUCT_VALIDATION: "De validação de produto",
                KIT_ASSEMBLY_SHRINKWRAP: "De montagem de kits e/ou aplicação de termoencolhimento",
                PACKAGING: "De embalagem",
                PRODUCT_SEGREGATION: "De segregação de produto"
            },
            work_order_product_origin: {
                ALL_INVENTORY_AT_WAREHOUSE: "Todo o material está armazenado no meu inventário na Cubbo disponível para venda",
                MATERIAL_IN_TRANSIT_TO_WAREHOUSE: "O material está a caminho do armazém",
                PARTIAL_MATERIAL_INVENTORY_IN_TRANSIT_TO_WAREHOUSE: "Parte do material está armazenado na Cubbo e parte está a caminho do armazém"
            },
            work_order_card: {
                update_work_order_status: "Atualizar status da maquila",
                save_button: "Salvar atualização",
                start_progress_button: "Iniciar progresso",
                complete_work_order_button: "Concluir maquila",
                reject_work_order_button: "Rejeitar maquila",
                complete_the_information_requested: "Complete as informações quando desejar iniciar a validação operacional da maquila",
                validate_order: "A solicitação possui tudo o que é necessário para passar pela validação operacional?",
                confirm_validation: "Sim, aceitar solicitação",
                reject_validation: "Não, rejeitar solicitação",
                complete_the_information_in_validation: "Complete as informações assim que a validação da maquila for concluída",
                necessary_pieces: "Todos as peças necessárias estão disponíveis para processamento da maquila?",
                estimated_operator_quantity: "Quantas pessoas se estima que serão designadas para processar a maquila?",
                estimated_labor_days_quantity: "Dias estimados de processamento",
                scheduled_order: "Esta solicitação foi agendada para próxima a iniciar",
                complete_the_information_in_progress: "Complete as informações assim que a maquila for concluída",
                confirm_operator_quantity: "Confirme o total de pessoas usadas na maquila",
                estimated_labor_days_quantity: "Confirme os dias estimados de processamento",
                completed_work_order: "Esta maquila foi concluída",
                rejected_work_order: "Esta maquila foi rejeitada",
                canceled_work_order: "Esta maquila foi cancelada",
                files_placeholder: "Clique aqui ou arraste seus arquivos PDF, Excel ou imagens"
            }
        },
        work_order_list: {
            header: {
                work_order_id: "Nº MAQUILA",
                customer: "CLIENTE",
                work_order_type: "TIPO",
                status: "ESTADO",
                created_at: "DATA DE SOLICITAÇÃO"
            },
            filters: {
                work_order_id: "Nº maquila",
                status: "Estado",
                work_order_type: "Tipo de maquila"
            },
            footer: {
                no_work_orders: "Não há maquilas para mostrar",
                work_order: "maquilas"
            },
            queued: "Em fila",
            view_work_order: "Ver maquila",
            on_date: "Em"
        }
    },
    replenishment_labels: {
        dialog_title: "Imprimir ID de recibo de inventário",
        label_title: "Identificador de recibo de inventário",
        label_instructions: "Imprima e cole esta etiqueta no pacote retornado para identificar o retorno ao realizar o armazenamento.",
        store: "Loja",
        warehouse: "Armazém",
        replenishment_id: "ID de recibo"
    },
    replenishment: {
        expected_quantity: "peças pendentes de receber",
        error_unexpected_stock_start: "O máximo de peças a receber por produto é a quantidade esperada. ",
        error_unexpected_stock_middle: "Ajuste a quantidade a ser recebida, limitando as peças pendentes a receber",
        error_unexpected_stock_end: " e separe as peças sobrantes para processá-las em outro recibo."
    },
    generate_shipment: {
        generate_label: 'Gerar Etiqueta',
        store: 'Loja',
        order: 'Pedido',
        tote: 'Tote',
        go_to_next_order: 'Ir ao pedido seguinte para esse produto',
        picking_incomplete: 'O picking deste pedido não foi completado',
        no_multiple_packages: 'O método de envio selecionado não permite multi-pacote',
        cod_not_allowed: 'O método de envio selecionado não permite pagamento contra reembolso',
        print_label: 'Imprimir Etiqueta',
        missing_information: 'Falta informação no pedido',
        cannot_generate_more_labels: 'Não é possível gerar mais guias para este pedido, por favor avise ao time de operações para realizar esta ação',
        no_more_orders: 'Não há mais pedidos pendentes de embalagem para esta SKU neste tote. Retorne ao módulo de geração de etiquetas e escaneie outro tote ou produto.',
        imei_duplicate: 'IMEI duplicado',
        surplus_product: 'Há um excedente deste produto.',
        product_not_in_order: 'Este produto não pertence ao pedido ou já foi revisado.',
        shipping_address: {
            order_details: 'Detalhes do pedido',
            see_details: 'Ver detalhes',
            hide_details: 'Ocultar detalhes',
            name: 'Nome',
            surname: 'Sobrenome',
            phone: 'Telefone',
            email: 'E-mail',
            address: 'Endereço',
            address_2: 'Apartamento, local, colonia, etc. (opcional)',
            country: 'País',
            city: 'Cidade',
            province: 'Estado / Província',
            zip_code: 'CEP',
            copy_address: 'Copiar endereço completo',
            address_copied: 'Endereço copiado!'
        },
        product_list: {
            required_products: 'Produtos requeridos',
            scan_all_items: 'Escaneie todos os itens do tote',
            order_complete: 'O pedido está completo!',
            sku: 'SKU',
            upc: 'UPC',
            quantity: 'Itens requeridos',
            processed_quantity: 'Itens revisados',
            actions: 'Estado de revisão',
            no_data: 'Sem dados',
            complete: 'Completo',
            pending: 'Pendente',
            product_search: {
                placeholder: 'Escaneie a etiqueta de um produto'
            },
            products_total: {
                item: 'produto',
                complete_singular: 'Foram revisados',
                complete_plural: 'Foi revisado',
                pending_singular: 'pendente de revisão',
                pending_plural: 'pendentes de revisão'
            },
            see_products: 'Ver produtos',
            hide_products: 'Ocultar produtos',
        },
        missing_picking_pieces: {
            title: 'Faltaram peças no picking?',
            scan_all_products: 'Escaneie todos os produtos do tote. ',
            missing_items: 'Se após finalizar ainda houverem peças faltantes, envie o pedido à revisão.',
            action: 'Enviar pedido à revisão'
        },
        fragile_notification: {
            title: 'Adicione material de proteção',
            description: 'Esse pedido contém produto frágil'
        },
        recommended_package: {
            title: 'Pacote recomendado',
            text_1: 'Somente se o pedido não contém a ',
            text_2: 'caixa do cliente, ',
            text_3: 'utilize:'
        },
        shipping_package_data: {
            title: 'Pacote utilizado',
            description: 'Registre como o pacote será enviado',
            package: 'Pacote',
            select_similar_package: 'Selecione um pacote com medidas semelhantes',
            shipping_method: 'Método de envio'
        },
        footer: {
            cancel: 'Cancelar',
            generate_label: 'Gerar Etiqueta',
            invalidate_previous_labels: 'Invalidar Etiquetas Anteriores e Gerar Etiqueta',
            generate_label_confirm: 'Deseja gerar esta etiqueta?',
            labels_invalidated: 'Se invalidarão todas as etiquetas anteriores e serão geradas novas etiquetas. Confirma Proceder?'
        },
        view: {
            tote_not_found: 'Tote inválido, informe ao time de operações',
            unexpected_error: 'Ocorreu um erro inesperado.',
            order_in_review: 'Este pedido se encontra em revisão.',
            order_not_packing: 'O pedido pertencente a este tote não se encontra em status Packing',
            order_not_found: 'Não foi encontrado um pedido com esse produto.',
            generate_label_title: 'Gerar Etiqueta',
            generate_label_button: 'Gerar Etiqueta Agrupada',
            scan_tote_title: 'Escaneie aqui o Tote da Cubbo',
            scan_tote_label: 'Buscar Tote',
            scan_tote_placeholder: 'Escanea um Tote',
            multiple_orders: 'Este Tote contém vários pedidos. Escaneie um produto do Tote.',
            scan_product_title: 'Este Tote contém vários pedidos. Escaneie um produto do Tote.',
            scan_product_label: 'Buscar UPC ou SKU',
            scan_product_placeholder: 'Escaneie um produto',
            missing_information: 'Falta informação no pedido',
            picking_not_completed: 'O picking deste pedido não foi completado',
            shipping_method_no_multipackage: 'O método de envio selecionado não permite multi-pacote',
            shipping_method_no_cod: 'O método de envio selecionado não permite pagamento contra reembolso',
            next_order_for_product: 'Ir ao pedido seguinte para este produto',
            invalidate_and_generate: 'Invalidar Etiquetas Anteriores e Gerar Etiqueta',
            invalidate_confirm: 'Serão invalidadas todas as etiquetas anteriores e serão geradas novas etiquetas. Confirma Proceder?',
            generate_confirm: 'Deseja gerar esta etiqueta?',
            product_not_in_order: 'Este produto não pertence ao pedido ou já foi revisado.',
            order_invoice_not_ready: 'A fatura ainda não está pronta para este pedido. Separe o pedido e tente novamente mais tarde.',
            order_notfis_not_ready: 'O NOTFIS ainda não está pronto para este pedido. Separe o pedido e tente novamente mais tarde.'
        }
    },
    generate_shared_label: {
        cancel: 'Cancelar',
        generate_label: 'Gerar Guía',
        generate_label_confirm: 'Deseja gerar esta guía?',
        yes: 'Sim',
        print_invoice: 'Imprimir Fatura Comercial',
        print_invoice_brazil: 'Imprimir Fatura Brasil',
        order_details: 'Detalhes do pedido',
        on_collapsed_text: 'Ver detalhes',
        on_not_collapsed_text: 'Ocultar detalhes',
        address: 'Endereço',
        address_2: 'Apartamento, local, colonia, etc. (opcional)',
        city: 'Cidade',
        province: 'Estado / Província',
        zip_code: 'CEP',
        grouped_orders: 'Pedidos Agrupados',
        scan_all_orders: 'Escaneie todos os pedidos que serão enviados',
        scan_order_placeholder: 'Escaneie a etiqueta do pedido',
        used_package: 'Pacote utilizado',
        register_package_shipping: 'Registre como o pacote será enviado',
        package: 'Pacote'
    },
    top_menu: {
        warehouses: 'Armazéns',
        billing: "Billing"
    },
    navegation_routes: {
        warehouses: 'Armazéns',
        billing: 'Billing',
        dashboard: 'Dashboard',
        pending: 'Pendentes',
        pick_and_pack: 'Pick & Pack',
        shipments: 'Envios',
        generate_labels: 'Gerar Guías',
        returns: 'Retornos',
        inventory: 'Inventário',
        load: 'Remessa',
        claims: 'Disputas',
        maquilas: 'Maquilas',
        operators: 'Operadores'
    },
    table_paginator: {
        page_by_page: 'por página',
        page: 'página',
        of: 'de',
        total_elements: 'elementos totais',
        previous: 'Anterior',
        next: 'Próximo'
    },
    list_warehouses: {
        warehouses: 'Armazéns',
        empty_table_text: 'Não há armazéns para mostrar.',
        headers: {
            warehouse: 'Armazém',
            address: 'Endereço',
            status: 'Estado',
            country: 'País',
            created_at: 'Criado'
        }
    },
    home: {
        pending_orders: 'Pedidos Pendentes',
        pending: 'Pendentes',
        processing_orders: 'Pedidos em Processamento',
        processing: 'Processamento',
        waiting_pick_up_orders: 'Pedidos Esperando Recoleção',
        waiting_pick_up: 'Esperando Recoleção',
        no_stock_orders: 'Pedidos Sem Estoque',
        no_stock: 'Sem Estoque',
        missing_info_orders: 'Pedidos com Falta de Informação',
        missing_info: 'Falta de Informação'
    },
    list_orders: {
        pending_orders: 'Pedidos Pendentes',
        empty_table_text: 'Não há pedidos para mostrar.',
        assign_orders: 'Atribuir Pedidos',
        store_search_placeholder: 'Buscar: -A, B',
        headers: {
            store: 'Loja',
            area: 'ÁREA',
            products: 'Produtos',
            max_packing_time: 'Embalar antes de',
            order_number: 'Nº DO PEDIDO',
            channel_name: 'Canal',
            shipping_type: 'Tipo de envio',
            shipping_method: 'MÉTODO DE ENVIO',
            same_day: 'Mesmo dia',
            standard: 'Padrão',
            store_search_help_1: 'Para buscar mais de uma loja use "," Ex: Levis, Dossier',
            store_search_help_2: 'Para omitir algumas lojas use "-" EX: -Levis, Dossier'
        },
        actions: {
            see_order: 'Ver pedido',
            generate_shipment: 'Gerar Etiqueta',
            pick_pieces: 'Pickear itens'
        }
    },
    list_processing_orders: {
        orders: 'Pedidos',
        title: 'Pedidos em Processamento',
        generate_shipments: 'Gerar Etiquetas',
        generate_shared_shipment: 'Gerar Etiqueta Agrupada',
        reassign_picker: 'Reatribuir Picker',
        reassign_picker_tooltip: 'Selecione apenas pedidos em estado de Picking ou em Processamento',
        empty_table_text: 'Não há pedidos para mostrar.',
        pick_all_success: 'Pedido pickeado com sucesso',
        headers: {
            store: 'Loja',
            order_number: 'Nº DE PEDIDO',
            max_packing_time: 'Embalar antes de',
            channel_name: 'Canal',
            tote: 'TOTE',
            assigned_to: 'Picker',
            status: 'Estado',
            shipping_method: 'MÉTODO DE ENVIO'
        },
        actions: {
            generate_shipment: 'Gerar Etiqueta',
            pick_pieces: 'Pickear itens'
        }
    },
    list_orders_shipped: {
        title: 'Pedidos Enviados',
        reassignment_of_orders: 'Reatribuir Pedidos',
        empty_table_text: 'Não há pedidos para mostrar.',
        headers: {
            order_number: 'Nº DO PEDIDO',
            shipping_method: 'MÉTODO DE ENVIO',
            shipping_type: 'Tipo de envio',
            status: 'Estado',
            shipping_status: 'Estado de envio',
            incident: 'Incidente'
        }
    },
    list_returns: {
        returns: 'Retornos',
        empty_table_text: 'Não há retornos para mostrar.',
        require_monitoring: 'Requerem monitoramento',
        statuses: {
            arrived_at_warehouse: 'Chegou ao armazém',
            awaiting_return: 'Aguardando retorno'
        },
        scan_package_title: 'Escaneie o pacote para identificar',
        scan_package_placeholder: 'Escaneie a guia de retorno, a ordem de packing list ou RMA ou a chave',
        headers: {
            store: 'Loja',
            returned_order_number: 'Nº DO PEDIDO RETORNADO',
            created_order_number: 'Nº DO NOVO PEDIDO',
            type: 'Tipo',
            status: 'Estado',
            shipping_number: 'Etiqueta de retorno',
            created_at: 'Data de criação'
        }
    },
    list_locations: {
        locations: 'Localizações',
        locations_by_product: 'Localizações por produto',
        location_to_export_description: 'Com localização igual ou parecida a ',
        sku_to_export_description: 'Com SKU igual ou parecido a ',
        upc_to_export_description: 'Com UPC igual ou parecido a ',
        store_to_export_description: 'Com nome de loja igual ou parecido a ',
        location_type_to_export_description: 'Com tipo de localização ',
        product_name_to_export_description: 'Com nome de produto igual ou parecido a ',
        export_all_products_description: 'Serão exportados todos os produtos do armazém. Se desejar, use os filtros para obter um relatório específico.',
        headers: {
            product_image_path: 'Imagem',
            location_code: 'Localização',
            store: 'Loja',
            location_type: 'Tipo',
            product_name: 'Nome do Produto',
            sku: 'SKU',
            upc: 'UPC',
            stock_total_count: 'Quantidade'
        },
        empty_table_text: 'Não há produtos para mostrar.',
        export_inventory_title: 'Exportar inventário',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        inventory: 'Inventário',
        inventory_history: 'Histórico de inventário',
        download: 'Download',
        export: 'Exportar'
    },
    list_claims: {
        title: 'Disputas',
        headers: {
            order_number: 'Nº DO PEDIDO',
            store_name: 'LOJA',
            status: 'ESTADO',
            accepted_value: 'VALOR ACEITO',
            area: 'ÁREA',
            category: 'CATEGORIA',
            created_at: 'DATA DE CRIAÇÃO'
        },
        empty_table_text: 'Não há disputas para mostrar.'
    },
    list_operators: {
        title: 'Gestão de Operadores',
        new_operator: 'Novo Operador',
        name: 'Nome',
        surname: 'Sobrenome',
        email: 'E-mail',
        password: 'Senha',
        copy_email: 'Copiar e-mail',
        generate_password: 'Gerar Senha',
        copy_password: 'Copiar Senha',
        create_operator: 'Criar Operador',
        operators: 'Operadores',
        search_by_name: 'Buscar por nome, sobrenome ou e-mail',
        search_by_role: 'Buscar por cargo',
        show_active_only: 'Mostrar somente usuários ativos',
        empty_table_text: 'Não há operadores para mostrar.',
        notifications: {
            copied: 'Copiado!',
            operator_created: 'Operador criado!',
            operator_roles_updated_success: 'Cargos atualizados com sucesso!',
            operator_updated_success: 'Operador atualizado com sucesso!',
            operator_deleted_success: 'Operador deletado com sucesso!',
        }
    },
    replenishments: {
        show_replenishment: {
            title: 'Agendamento de Recibo',
            products: 'Produtos',
            sell_ahead: 'Pré-venda',
            not_sell_ahead: 'Não-pré-venda',
            open_receipt: 'Voltar a abrir remessa',
            complete_receipt: 'Completar Remessa',
            modify_lots: 'Modificar lotes do último produto escaneado',
            edit_lots: 'Editar lotes',
            finish_check_in: 'Terminar check-in',
            receipt_correction: 'Correcção de remessa',
            name: 'Nome',
            skus: 'SKUs',
            upc: 'UPC',
            new_quantity: 'Novo número de peças em recebimento',
            cancel: 'Cancelar',
            correct: 'Corrigir',
            continue: 'Continuar',
            no_pieces_in_receipt: 'Não há nenhuma peça em remessa',
            attention: 'Atención',
            accept: 'Aceitar',
            scan_product: 'Escanea o produto para identificar',
            products_with_lots: 'produtos com lotes registrados',
            filter_no_lots: 'Produtos sem lote registrado',
            receipt_stage_complete: 'Stage de Remessa Completo mas ainda há peças por localizar em Put Away.',
            segregated_check: 'O produto vem corretamente separado.',
            labeled_check: 'O produto vem corretamente etiquetado.',
            inventory_receipt: 'Recibo de inventário',
            no_lot: 'Não tem lote',
            no_lot_required: 'Não requer lote',
            replenishment_completed: 'Remessa concluída',
            quality_check: 'Controle de qualidade',
            received_pieces: 'Peças recebidas',
            damaged_dialog_1: 'Mova ',
            damaged_dialog_2: ' peças para a localização: D-1-1-1 e clique em continuar',
            complete_dialog_1: 'Há ',
            complete_dialog_2: ' produtos com peças em remessa. Aceita completar a remessa e que essas peças sejam eliminadas?',
            how_many_boxes: 'Quantos bultos/caixas vêm neste recibo?',
            attended_appointment: 'Cumpriu com agendamento.',
            mark_as_received: 'Marcar como recebido',
            receive: 'Receber',
            damaged: 'Danificado',
            product_exists_but_not_in_receipt: 'Este produto existe na loja, mas não está no recibo',
            add_to_receipt: 'Adicionar ao recibo',
            start_check_in: 'Iniciar check-in',
            count_pieces_by_sku_or_upc: 'Conta peças por SKU ou UPC',
            start: 'Iniciar',
            searching: 'Buscando...',
            product_not_found: 'O SKU buscado não existe',
            select_lot: 'Este produto tem mais de um lote, selecione um para continuar',
            store_not_configured: 'Esta loja não foi configurada para poder iniciar o recibo. Por favor, contacte o representante de vendas da loja.',
            notifications: {
                quality_check_saved: 'Quality check guardado',
                duplicate_product_added: 'Este produto já foi adicionado ao recibo anteriormente'
            },
            columns: {
                lot: 'Lote',
                name: 'Nome',
                sku: 'SKU',
                upc: 'UPC',
                counted: 'Contadas',
                actions: 'Ações',
                expected_quantity: 'Esperadas',
                processed_quantity: 'Processadas',
                in_reception: 'Em recebimento'
            },
            how_many_boxes_in_receipt: "Quantas caixas chegaram?",
        },
        show_replenishment_boxes: {
            in_putaway: "Etapa de Recebimento Concluída, mas ainda há peças para localizar no Put Away.",
            completed: "Etapa de Recebimento Concluída",
            start_check_in_title: "Iniciar check-in",
            start_chcek_in_button: "Iniciar",
            complete_receive_button: "Não há mais peças para contar",
            complete_putaway_button: "Finalizamos o putaway",
            reopen_button: "Voltar para contar peças",
            last_movements: "Últimos produtos que escaneei",
            complete_replenishment_dialog: {
                received_less_than_expected_title: "Diferenças detectadas",
                received_less_than_expected_description: "Para alguns produtos, foram contadas menos peças do que o esperado",
                received_less_than_expected_confirm_question: "Tem certeza de que não há mais peças para contar?",
                confirm_button: "Confirmar",
                cancel_button: "Voltar e revisar"
            },
            receive_options: {
                title: "O que você vai contar agora?",
                options: {
                    complete_boxes: "Caixas completas",
                    uncomplete_boxes: "Caixas parciais"
                },
                receiving_title: "Você está contando",
                scan_input_title: "Escaneie o código da caixa",
                scan_input_placeholder: "Escaneie",
                scan_input_receing: "Recebendo caixa..."
            },
            scan_quantity_barcode_dialog: {
                title: "Peças contidas na caixa",
                description: "Escaneie o código da caixa com a quantidade do produto ou digite a quantidade",
                scan_input_placeholder: "Escaneie o código ou digite a quantidade",
                confirm_button: "Inserir"
            },
            received_boxes_table: {
                columns: {
                    product_name: "Nome",
                    scanned_box: "Caixa escaneada",
                    lot: "Lote | Expiração",
                    sku: "SKU | UPC",
                    expected: "Peças esperadas",
                    received: "Peças recebidas",
                    received_boxes: "Total de caixas recebidas",
                    received_pieces: "Total de peças recebidas",
                    pieces_status: "Estado das Peças",
                    in_putaway: "Em Putaway",
                    actions: ""
                },
                complete_boxes_plural: "{{quantity}} caixas completas",
                uncomplete_boxes_plural: "{{quantity}} caixas parciais",
                not_damaged_pieces_plural: "{{quantity}} bom estado",
                damaged_pieces_plural: "{{quantity}} danificadas",
                fix_DAMAGED_button: "Corrigir danificadas",
                fix_PUTAWAY_button: "Corrigir quantidade",
                send_to_damage_button: "Danificada",
                empty_table: "Sem conteúdo",
                empty_movements: "Nenhum movimento registrado ainda",
                cannot_edit_damaged: "Não é possível corrigir danificadas porque não há peças recebidas",
                cannot_edit_quantity: "Não é possível corrigir a quantidade porque não há peças recebidas",
                cannot_send_to_damage: "Não é possível enviar para danificado porque não há peças recebidas",
                damaged_pieces_dialog: {
                    title: "Quantas peças deste produto deseja marcar como danificadas?",
                    description: "Separe as peças para colocá-las em uma posição de danificado no armazém",
                    confirm_button: "Confirmar",
                    cancel_button: "Cancelar"
                },
                fix_quantity: {
                    PUTAWAY_title: "Correção de peças aguardando putaway",
                    DAMAGED_title: "Correção de peças danificadas",
                    product_name: "Nome do produto",
                    sku: "SKU | UPC",
                    lot: "Lote | Expiração",
                    PUTAWAY_description: "Quantidade atualizada de peças aguardando putaway",
                    DAMAGED_description: "Quantidade atualizada de peças danificadas",
                    confirm_button: "Atualizar",
                    cancel_button: "Cancelar"
                },
                filters: {
                    sku: {
                        title: "SKU"
                    },
                    upc: {
                        title: "UPC"
                    },
                    lot_unique_code: {
                        title: "Código do lote"
                    },
                    box_barcode: {
                        title: "Código de barras da caixa"
                    },
                    pending_to_receive: {
                        title: "Com peças pendentes de recebimento"
                    },
                    pending_to_putaway: {
                        title: "Com peças pendentes de putaway"
                    }
                }
            },
            errors: {
                send_pieces_to_damage: "Ocorreu um erro ao enviar para danificado, foi relatado o seguinte erro: '{{error_data}}'",
                adjust_putaway_pieces: "Ocorreu um erro ao ajustar peças no putaway, foi relatado o seguinte erro: '{{error_data}}'",
                invalid_barcode: "O código que você escaneou '{{barcode}}' não corresponde ao código de barras de uma caixa da loja. Tente novamente e, se o erro persistir, peça ajuda ao time de tech para validar o formato do código",
                receive_error: "Não foi possível receber a caixa, foi relatado o seguinte erro: '{{error_data}}'",
                quality_check_error: "Ocorreu um erro na verificação de qualidade, foi relatado o seguinte erro: '{{error_data}}'",
                start_error: "Ocorreu um erro ao iniciar o recebimento, foi relatado o seguinte erro: '{{error_data}}'",
                complete_receive_error: "Ocorreu um erro ao completar o recebimento de peças, foi relatado o seguinte erro: '{{error_data}}'",
                complete_putaway_error: "Ocorreu um erro ao completar o putaway, foi relatado o seguinte erro: '{{error_data}}'",
                receive_damaged_error: "Ocorreu um erro ao enviar as peças para danificado, foi relatado o seguinte erro: '{{error_data}}'"
            },
            error_codes: {
                lot_not_found: "Esta caixa não pode ser recebida, pois o lote do produto não está registrado na loja. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'",
                sku_not_found: "Esta caixa não pode ser recebida, pois o SKU do produto não está registrado na loja. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'",
                no_expected_product_quantity: "Este produto não era esperado neste recebimento, portanto não pode ser inserido. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'",
                unexpected_product_count: "Já foram recebidas todas as unidades esperadas deste produto. Envie uma foto deste erro e da etiqueta da caixa para o time de tech validar o caso. Contexto para tech: '{{context}}'"
            },
            receive_progress_bar: {
                title: "Progresso geral do recebimento",
                remaining_pieces: "Faltam {{quantity}} peças para receber",
                received_boxes: "{{complete_boxes}} caixas completas e {{uncomplete_boxes}} caixas parciais",
                update_quantity: "Corrigir quantidades recebidas",
                show_breakdown: "Ver detalhamento das peças",
                general_quantity: "{{received_pieces}} de {{expected_pieces}} peças contadas"
            },
            putaway_progress_bar: {
                title: "Progresso geral do putaway",
                remaining_pieces: "Faltam {{quantity}} peças recebidas para completar o putaway",
                update_quantity: "Corrigir quantidades recebidas",
                show_breakdown: "Ver detalhamento das peças",
                general_quantity: "{{putaway_pieces}} de {{check_in_pieces}} peças recebidas com putaway concluído"
            },
            breakdown: {
                title: "Detalhes das peças do recebimento"
            }
        },
        inventory_receipt: 'Recibo de inventário'
    },
    list_active_replenishments: {
        replenishment: 'Remessa',
        replenishments: 'Remessas',
        empty_table_text: 'Não há remessas de inventário para mostrar.',
        receive: 'Receber',
        reverse_logistics_replenishments: 'Remessas de Logística Reversa',
        headers: {
            id: 'Id',
            store: 'Loja',
            notes: 'Notas',
            status: 'Estado',
            created_at: 'Data de criação',
            sell_ahead: 'Pré-venda',
            has_expirations: 'Tem expirações',
            actions: 'Ações'
        }
    },
    common: {
        yes: "Sim",
        accept: "Aceitar",
        cancel: "Cancelar",
        warning: "Atenção!",
        order: 'Pedido',
        orders: 'Pedidos',
        shipments: 'Envios',
        returns: 'Retornos',
        inventory: 'Inventário',
        claims: 'Disputas',
        maquilas: 'Maquilas',
        operators: 'Operadores',
        warehouse: 'Armazém',
        locations: 'Localizações',
        previous: 'Anterior',
        next: 'Seguinte'
    }
}
